import { selectConfigValue } from '../../../shared/selectors/config';

export default [
  '$http',
  '$q',
  'store',
  function($http, $q, store) {
    const state = store.getState();
    const demandBrowserUrl = selectConfigValue('demandBrowserUrl', state);

    const isRequiredParamsAssigned = params => {
      return params.every(param => typeof param !== 'undefined' && param !== null);
    };

    const getUserHasActiveMessage = userId => {
      if (!isRequiredParamsAssigned([userId])) {
        return $q.reject();
      }

      const headers = {
        'Cache-Control': undefined,
        Pragma: undefined,
      };

      return $http.get(
        demandBrowserUrl + `/v1/user-has-active-messages/?userId=${userId}`,
        { withCredentials: true, headers },
        { allowServerErrors: true },
      );
    };

    return {
      getUserHasActiveMessage,
    };
  },
];
